import React, { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X, Phone, Calendar } from "lucide-react";
import { Logo } from "./Logo";
import { NAV, SITE } from "../lib/site";

const Header = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  return (
    <header className="sticky top-0 z-40 bg-cream/95 backdrop-blur border-b border-forest/10" data-testid="site-header">
      <div className="container-soft flex items-center justify-between h-20">
        <Link to="/" className="shrink-0" data-testid="header-logo-link" onClick={() => setOpen(false)}>
          <Logo height={52} />
        </Link>

        <nav className="hidden lg:flex items-center gap-0.5" aria-label="Main">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              data-testid={`nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) =>
                `px-3 xl:px-4 py-2 rounded-full text-sm xl:text-base font-semibold whitespace-nowrap transition-colors ${
                  isActive ? "bg-forest text-cream" : "text-forest hover:bg-forest/10"
                }`
              }
              end={n.to === "/"}
            >
              {n.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <a href={SITE.tel} className="btn-ghost h-12 px-4 text-base whitespace-nowrap" data-testid="header-call-link" aria-label={`Call ${SITE.phoneDisplay}`}>
            <Phone className="w-5 h-5" strokeWidth={2} />
            <span className="hidden xl:inline">{SITE.phoneDisplay}</span>
          </a>
          <Link to="/contact#booking" className="btn-primary h-12 px-5 text-base whitespace-nowrap" data-testid="header-book-button">
            <Calendar className="w-5 h-5" strokeWidth={2} />
            Book a Free Call
          </Link>
        </div>

        <button
          aria-label="Open menu"
          className="lg:hidden p-2 rounded-full hover:bg-forest/10 text-forest"
          onClick={() => setOpen((v) => !v)}
          data-testid="mobile-menu-toggle"
        >
          {open ? <X className="w-7 h-7" /> : <Menu className="w-7 h-7" />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-forest/10 bg-cream" data-testid="mobile-menu">
          <div className="container-soft py-4 flex flex-col gap-1">
            {NAV.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
                className={({ isActive }) =>
                  `px-4 py-3 rounded-2xl text-lg font-semibold ${
                    isActive ? "bg-forest text-cream" : "text-forest hover:bg-forest/10"
                  }`
                }
                end={n.to === "/"}
              >
                {n.label}
              </NavLink>
            ))}
            <a href={SITE.tel} className="mt-2 btn-ghost" data-testid="mobile-call-link" onClick={() => setOpen(false)}>
              <Phone className="w-5 h-5" /> Call Sarah
            </a>
            <Link to="/contact#booking" onClick={() => setOpen(false)} className="btn-primary mt-2" data-testid="mobile-book-button">
              <Calendar className="w-5 h-5" /> Book a Free Call
            </Link>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
